import { useState } from "react";
import { useEffect, useRef } from "react";
import './Currency.scss';
import RandomCounter from "../RandomCounter/RandomCounter";

const Currency = () => {
    const useFocus = () => {
        const htmlElRef = useRef(null)
        const setFocus = () => {htmlElRef.current &&  htmlElRef.current.focus()}
        return [ htmlElRef, setFocus ] 
    }
    const [inputRef, setInputFocus] = useFocus();
    const [data, setData] = useState([]);
    const [currency, setCurrency] = useState(0);
    const [value, setValue] = useState('');
    const [output, setOutput] = useState('0 ₽');
    useEffect(() => {
        const getRequest = async () => {
            const request = await fetch('https://www.cbr-xml-daily.ru/daily_json.js');
            const response = await request.json()
            setData(response)
        };
        getRequest()
    }, [])
    const firstCurrency = (e) => {
        if (e.target.value === 'none') { 
            return setCurrency(0);
        }
        const dataValute = data.Valute;
        const arr = Array.of(...Object.values(dataValute))
        arr.forEach((item, i) => {
            if (arr[i].CharCode === e.target.value) {
                setCurrency(currency => arr[i])
            }
        })
    }
    const carancyExchange = (e) => {
        if (currency === 0 ) { 
            e.target.value = '';
        } else {
            setValue(e.target.value.substring(0, 17));
            setOutput(`${Math.floor(e.target.value * currency.Value).toLocaleString("de-DE")} ₽`)
        }
    }
    const clearValue = () => {
        setValue('');
        setOutput('0 ₽')
    }
    return (
        <div className="currency">
            <h1>Конвертер валют  </h1>
            <p>Для корректной работы сначала надо выбрать Валюту</p>
            <div className="currency__block">
                <select className="currency__select" onChange={firstCurrency} placeholder="Выберите Валюту" >
                    <option value="none">Выберите валюту</option>
                        <option value="AMD">AMD - Австралийский доллар  </option>
                        <option value="BYN">BYN - Белорусский рубль</option>
                        <option value="CNY">BYN - Китайских юаней</option>
                        <option value="EUR">EUR - Евро</option>
                        <option value="JPY">JPY - Японский Иен</option>
                        <option value="KZT">KZT - Казахстанских тенге тенге</option>
                        <option value="UAH">UAH - Украинский гривен</option>
                        <option value="USD">USD - Доллар США</option>
                        <option value="HKD">HKD - Гонконгских долларов</option>
                </select>
                <div className="currency__output"> Итог: {output}  </div>
                <div className="currency__descr"> Курс: RU - {currency.CharCode } {currency.Value}  </div>
                <input ref={inputRef} type="number" value={value} inputMode="numeric" placeholder="Введите сумму " onChange={carancyExchange}  />
                <button onClick={() => { clearValue(); setInputFocus()}} >Очистить данные</button>
            </div>
            <RandomCounter/>
        </div>
    )
}

export {Currency} ;